<section>
  <div class="form-group reorder-report-div">
    <div class="reorder-report-left-div">
      <input type="checkbox" class="k-checkbox checkboxSize" #onlyReorder [checked]="isonlyReorder" (change)="filterOnlyReorderItems($event)"  />
      <label class="lbl-reorder" [for]="onlyReorder">{{reorderReportLblText.onlyReorderItems}} </label>
    </div>
    <div class="reorder-report-right-div">
      <input type="checkbox" class="k-checkbox checkboxSize" #inactiveReorderItem [checked]="isInActiveReorder" (change)="filterInActiveReorderItems($event)" />
      <label class="lbl-reorder" [for]="inactiveReorderItem">{{reorderReportLblText.inactiveReorderItems}} </label>
    </div>
  </div>
</section>
<section>
  <kendo-grid [data]="reorderHeaderGridData"
              class="reorderSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="reorderGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="reorderGridstate.take"
              [skip]="reorderGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="reorderHeaderGridSortChange($event)"
              (pageChange)="reorderHeaderGridPageChange($event)"
              (dataStateChange)="reorderHeaderGridDataStateChange($event)"
              [filter]="reorderGridSettings.state.filter"
              [loading]="reorderLoading">
    <!--(columnReorder)="onReorder($event)"
  (columnVisibilityChange)="onVisibilityChange($event)"-->

    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-button-display btn-web">
        <button kendoButton class="excel-button " icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
          {{reorderReportLblText.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button " [disabled]="loadingPDF" (click)="generatePDF()">
          {{reorderReportLblText.exportToPDFLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>
    </ng-template>
    <kendo-grid-column *ngFor="let col of reorderGridSettings.columnsConfig" [headerClass]="'wrapheader-sample-admin-grid'"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'currentCostId'">
        {{dataItem.currentCostId | currency}}
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isActive'">
        <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'" [disabled]="true"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field == 'isReorder'">
        <span *ngIf="dataItem.isReorder == 'Yes'" class="red"> {{dataItem.isReorder}}</span>
        <span *ngIf="dataItem.isReorder == 'No'"> {{dataItem.isReorder}}</span>
      </ng-template>
      <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem
                 *ngIf="col.field == 'isActive'">
      <app-grid-dropdown-filter [filter]="filter" [data]="activeList" textField="name" valueField="activeStatus">
      </app-grid-dropdown-filter>
    </ng-template>-->
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
    <!--[data]="data"-->
    <kendo-excelexport [collapsible]="true" fileName="SampleRequestReorderReport.xlsx" #excelexport>
      <kendo-excelexport-column field="stockNum" title="Stock #" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="categoryName" title="Category" [width]="200">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="subCategoryDescription" title="Product Description" [width]="250">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="currentCostId" title="Cost" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="stockingLevel" title="Stocking Levek" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="currentInventory" title="Current Inventory" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="reorderPoint" title="Reorder Point" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="isActive" title="Active" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="isReorder" title="Reorder?" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="avgUsagePerMonth" title="Avg Usage/Mo" [width]="150">
      </kendo-excelexport-column>
      <kendo-excelexport-column field="noOfMonths" title="No of Months" [width]="150">
      </kendo-excelexport-column>
    </kendo-excelexport>
  </kendo-grid>
</section>
